export default __webpack_public_path__ + "img/t3_2.3df84347.png";